import request from '@/utils/request'
/**
 *
 * 赛事管理
 *
 **/
// 新增---新建竞赛
export const addCompetition = (params: any) => {
  return request({
    url: '/competition',
    method: 'post',
    data: { ...params }
  })
}

// 获取标题列表接口
export const getTitleList = (params: any) => {
  return request({
    url: '/competition/page',
    method: 'get',
    params
  })
}

// 获取赛事完整度接口
export const getTitleIntegrityList = (params: any) => {
  return request({
    url: '/competition/integrity',
    method: 'get',
    params
  })
}


// 修改---新建竞赛
export const updateCompetition = (params: any) => {
  return request({
    url: '/competition',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryCompetitionById = (params: any) => {
  return request({
    url: `/competition/${params.id}`,
    method: 'get',
    params: {
      type: params.type
    }
  })
}

// 修改---启用禁用接口
export const enableOrDisableCompetition = (params: any) => {
  return request({
    url: `/competition/status/${params.status}`,
    method: 'post',
    params: { id: params.id,type: params.type,titleId: params.titleId }
  })
}

// 删除接口
export const deleteCompetition = (params) => {
  return request({
    url: '/competition',
    method: 'delete',
    params: { ids:params.ids,type:params.type }
  })
}

// 赋权
export const empowermentCompetition = (params) => {
  return request({
    url: '/competitionEmployee/empowerment',
    method: 'post',
    params: { ids:params.ids,id:params.id }
  })
}

// 去权
export const disempowermentCompetition = (params) => {
  return request({
    url: '/competitionEmployee/empowerment',
    method: 'delete',
    params: { ids:params.ids,id:params.id }
  })
}

// 批量去权
export const disempowermentBeachIdsCompetition = (params) => {
  return request({
    url: '/competitionEmployee/empowerment/delete',
    method: 'delete',
    params: { ids:params.ids }
  })
}

// 根据员工id获取赛事员工关系表的数据
export const getCompetitionEmployee = (params: any) => {
  return request({
    url: '/competitionEmployee/empowerment',
    method: 'get',
    params: { id:params.id }
  })
}

// 获取赛事员工关系列表接口
export const getCompetitionEmployeeList = (params: any) => {
  return request({
    url: '/competitionEmployee/empowerment/page',
    method: 'get',
    params
  })
}

// 获取小程序列表接口
export const getSmallProgramList = (params: any) => {
  return request({
    url: '/smallProgram/page',
    method: 'get',
    params
  })
}

// 删除小程序
export const deleteSmallProgram = (params) => {
  return request({
    url: '/smallProgram',
    method: 'delete',
    params: { ids:params.ids,type:params.type }
  })
}

// 获取客服列表接口
export const getServiceList = (params: any) => {
  return request({
    url: '/component/page',
    method: 'get',
    params
  })
}

// 删除小程序
export const deleteService = (params) => {
  return request({
    url: '/component',
    method: 'delete',
    params: { ids:params.ids,type:params.type }
  })
}

// 修改---启用禁用接口
export const enableOrDisableService = (params: any) => {
  return request({
    url: `/component/status/${params.status}`,
    method: 'post',
    params: { id: params.id,type: params.type,titleId: params.titleId }
  })
}

// 新增---新建竞赛
export const addService = (params: any) => {
  return request({
    url: '/component',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新建竞赛
export const updateService = (params: any) => {
  return request({
    url: '/component',
    method: 'put',
    data: { ...params }
  })
}


// 修改页面反查详情接口
export const queryServiceById = (params: any) => {
  return request({
    url: `/component/${params.id}`,
    method: 'get',
    params: {
      type: params.type
    }
  })
}

// 新增---新建喔图
export const addOpen = (params: any) => {
  return request({
    url: '/userOpen',
    method: 'post',
    data: { ...params }
  })
}

// 获取喔图列表接口
export const getOpen = (params: any) => {
  return request({
    url: '/userOpen/page',
    method: 'get',
    params
  })
}

// 修改---新建喔图
export const updateOpen = (params: any) => {
  return request({
    url: '/userOpen',
    method: 'put',
    data: { ...params }
  })
}

// 修改---新建小程序
export const updateSmallProgram = (params: any) => {
  return request({
    url: '/smallProgram',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口（小程序）
export const querySmallProgramById = (params: any) => {
  return request({
    url: `/smallProgram/${params.id}`,
    method: 'get',
    params: {
      type: params.type
    }
  })
}

// 修改页面反查详情接口（喔图）
export const queryOpenById = (params: any) => {
  return request({
    url: `/userOpen/${params.id}`,
    method: 'get',
    params: {
      type: params.type
    }
  })
}

// 修改---启用禁用接口（喔图）
export const enableOrDisableOpen = (params: any) => {
  return request({
    url: `/userOpen/status/${params.status}`,
    method: 'post',
    params: { id: params.id,type: params.type,titleId: params.titleId }
  })
}

// 删除接口（喔图）
export const deleteOpen = (params) => {
  return request({
    url: '/userOpen',
    method: 'delete',
    params: { ids:params.ids,type:params.type }
  })
}

// 新增---新建开屏
export const addUserOpen = (params: any) => {
  return request({
    url: '/open',
    method: 'post',
    data: { ...params }
  })
}

// 获取开屏列表接口
export const getUserOpen = (params: any) => {
  return request({
    url: '/open/page',
    method: 'get',
    params
  })
}

// 修改---新建开屏
export const updateUserOpen = (params: any) => {
  return request({
    url: '/open',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口（开屏）
export const queryUserOpenById = (params: any) => {
  return request({
    url: `/open/${params.id}`,
    method: 'get',
    params: {
      type: params.type
    }
  })
}

// 修改---启用禁用接口（开屏）
export const enableOrDisableUserOpen = (params: any) => {
  return request({
    url: `/open/status/${params.status}`,
    method: 'post',
    params: { id: params.id,type: params.type,titleId: params.titleId }
  })
}

// 删除接口（开屏）
export const deleteUserOpen = (params) => {
  return request({
    url: '/open',
    method: 'delete',
    params: { ids:params.ids,type:params.type }
  })
}
